
import {
  defineComponent, onMounted, ref,
} from 'vue';
import AppHeader from '@/components/AppHeader.vue';
// eslint-disable-next-line import/no-cycle
import { useMainStore } from '@/store/mainStore';
import DesktopHeader from '@/components/desktop/DesktopHeader.vue';
import DriveAsideMainMenu from '@/modules/drive/components/desktop/DriveAsideMainMenu.vue';

export default defineComponent({
  components: {
    DriveAsideMainMenu,
    DesktopHeader,
    AppHeader,
  },
  setup() {
    const mainStore = useMainStore();
    const enableAll = ref(false);

    function updateNotificationSettings() {
      mainStore.updateNotificationSettings();
    }

    function switchAll(mode: boolean) {
      enableAll.value = mode;
      mainStore.notificationSettings = {
        mail: mainStore.notificationSettings.mail.map((notification) => ({
          ...notification,
          enabled: mode,
        })),
        push: mainStore.notificationSettings.push.map((notification) => ({
          ...notification,
          enabled: mode,
        })),
      };

      updateNotificationSettings();
    }

    function setEnabledAll() {
      enableAll.value = mainStore.notificationSettings.mail.every((el) => el.enabled) && mainStore.notificationSettings.push.every((el) => el.enabled);
    }

    onMounted(() => {
      setEnabledAll();
    });

    return {
      mainStore,
      enableAll,
      switchAll,
      updateNotificationSettings,
    };
  },
});
